<template>
    <pagina-erro-component origem="PaginaNaoEncontrada"></pagina-erro-component>
</template>

<script>
import PaginaErroComponent from '@/components/PaginaErroComponent.vue';

export default {
    name: 'PaginaNaoEncontrada',
        
    components: {
        PaginaErroComponent
    }
}
</script>